import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import { Link } from "react-router-dom";
import paginationFactory from "react-bootstrap-table2-paginator";
import { fetchArtikelen, deleteArtikel } from "../Reducers/actions";

const ArtikelenPage = () => {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const artikelen = useSelector((state) => state.gastenverbruik.artikelen || []);
  
  useEffect(() => {
    dispatch(fetchArtikelen())
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  }, [dispatch]);

  const handleDelete = (id) => {
    if (window.confirm("Weet je zeker dat je dit artikel wilt verwijderen?")) {
      dispatch(deleteArtikel(id)).then(() => {
        dispatch(fetchArtikelen());
      });
    }
  };

  const columns = [
    {
      dataField: "title",
      text: "Titel",
      sort: true,
    },
    {
      dataField: "artiekelnummer",
      text: "Artikelnummer",
    },
    {
      dataField: "ampere",
      text: "Ampere",
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell) => (
        <span className={`badge ${cell === "actief" ? "badge-success" : cell === "inactief" ? "badge-danger" : "badge-warning"}`}>
          {cell || "Onbekend"}
        </span>
      ),
    },
    {
      dataField: "created",
      text: "Aangemaakt",
      formatter: (cell) => {
        if (!cell) return "-";
        const date = new Date(cell);
        return date.toLocaleDateString("nl-NL");
      },
      sort: true,
    },
    {
      dataField: "_id",
      text: "Acties",
      formatter: (cell, row) => (
        <div>
          <Link className="btn btn-sm btn-warning mx-1" to={`/gastenverbruik/artikelen/edit/${row._id}`}>
            Wijzigen
          </Link>
          <button className="btn btn-sm btn-danger" onClick={() => handleDelete(row._id)}>
            Verwijderen
          </button>
        </div>
      ),
      headerStyle: { width: "200px" },
    },
  ];

  return (
    <div className="box box-default">
      <div className="box-header with-border">
        <h3 className="box-title">Artikelen</h3>
        <div className="box-tools pull-right">
          <Link className="btn btn-primary btn-sm" to="/gastenverbruik/artikelen/insert">
            <i className="fa fa-plus"></i>&nbsp; Artikel Toevoegen
          </Link>
        </div>
      </div>
      <div className="box box-default">
        <div className="row">
          <div className="col-md-12">
            <div className="box box-primary">
              <div className="box-body">
                {loading ? (
                  <p>Laden...</p>
                ) : (
                  <BootstrapTable
                    wrapperClasses="table-responsive-md"
                    keyField="_id"
                    data={artikelen}
                    columns={columns}
                    pagination={paginationFactory()}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArtikelenPage;